<template>
    <div class="container">
        <div class="head_bg">
            <common-head></common-head>
            <div class="head_content">
                <div>
                    <p>加入我们</p>
                    <div></div>
                </div>
            </div>
        </div>
        <div class="bg_c_g body_content">
            <h1>福利待遇</h1>
            <div class="dy_list">
                <div class="dy_list_items">
                    <img src="../assets/images/fuli_1.png" alt="">
                    <div>
                        <p>津贴与补助</p>
                        <p>餐补+班车及交通补+全勤奖+五险一金</p>
                    </div>
                </div>
                <div class="dy_list_items">
                    <img src="../assets/images/fuli_2.png" alt="">
                    <div>
                        <p>假期</p>
                        <p>双休及法定节假日</p>
                    </div>
                </div>
                <div class="dy_list_items">
                    <img src="../assets/images/fuli_3.png" alt="">
                    <div>
                        <p>定期团建</p>
                        <p>聚餐/K歌/度假村等，由你说了算！</p>
                    </div>
                </div>
                <div class="dy_list_items">
                    <img src="../assets/images/fuli_4.png" alt="">
                    <div>
                        <p>年度旅游</p>
                        <p>世界很大，咱们一起出去看看。</p>
                    </div>
                </div>
                <div class="dy_list_items">
                    <img src="../assets/images/fuli_5.png" alt="">
                    <div>
                        <p>休闲时间</p>
                        <p>零食区！健身房！母婴室！休息室！</p>
                    </div>
                </div>
                <div class="dy_list_items">
                    <img src="../assets/images/fuli_6.png" alt="">
                    <div>
                        <p>其他福利</p>
                        <p>年度体检，生日礼物，节假日福利</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="bg_c_w body_content">
            <h1>办公环境</h1>
            <van-swipe :autoplay="3000" indicator-color="white">
                <van-swipe-item>
                    <img class="hj_img" src="../assets/images/hj_1.png" alt="">
                </van-swipe-item>
                <van-swipe-item>
                    <img class="hj_img" src="../assets/images/hj_2.png" alt="">
                </van-swipe-item>
                <van-swipe-item>
                    <img class="hj_img" src="../assets/images/hj_3.png" alt="">
                </van-swipe-item>
                <van-swipe-item>
                    <img class="hj_img" src="../assets/images/hj_4.png" alt="">
                </van-swipe-item>
                <van-swipe-item>
                    <img class="hj_img" src="../assets/images/hj_5.png" alt="">
                </van-swipe-item>
            </van-swipe>
        </div>

        <div class="bg_c_g body_content">
            <h1>加入我们</h1>
            <div class="job_content_section">
                <span>职位名称</span>
                <span>职位类别</span>
                <span>操作</span>
            </div>

            <div v-for="(jobDetail, index) in jobDetailData" :key="index">
                <div class="job_content_cell" :class="{'job_content_cell_selected':currentIndex==index}" @click="handleClick(index)">
                    <span>{{jobDetail.Name}}</span>
                    <span>{{jobDetail.Type}}</span>
                    <span>
                        <a href="mailto:zhaopin@duomai.com">现在申请</a>
                    </span>
                </div>
                <transition name="fade">
                    <div class="job_content_detail" v-show="currentIndex==index">
                        <div>
                            <p>岗位职责：</p>
                            <pre>{{ jobDetail.Desc }}</pre>
                        </div>
                        <div>
                            <p>岗位要求：</p>
                            <pre>{{ jobDetail.Requirement }}</pre>
                        </div>
                        <a href="mailto:zhaopin@duomai.com">现在申请</a>
                    </div>
                </transition>

            </div>
        </div>

        <common-footer></common-footer>
    </div>
</template>

<script>
import commonHead from '../components/common-head.vue'
import commonFooter from '../components/common-footer.vue'
export default {
    data() {
        return {
            jobTypeData: [],
            jobDetailData: [],
            page: 1,
            pageSize: 50,
            totalPage: 0,
            currentIndex: 's',
        }
    },
    components: {
        commonHead,
        commonFooter
    },
    created() {
        const { getJob } = this
        getJob()
    },
    methods: {
        getJob() {
            this.$http.get("site/job", {
                params: {
                    Page: this.page, Pagesize: this.PageSize
                }
            }).then(response => {
                this.jobTypeData = response.d.Types;
                this.jobDetailData = response.d.Results;
                this.totalPage = response.d.TotalPage;
            });
        },

        handleClick(index) {
            this.currentIndex = this.currentIndex == index ? 's' : index
        }
    }
}
</script>

<style lang="less" scoped>
.head_bg {
    background-image: url("../assets/images/banner_con.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    & .head_content {
        height: 95px;
        position: relative;
        & > div {
            position: absolute;
            top: 41px;
            left: 20px;
            & > p {
                font-size: 20px;
                color: #ffffff;
                margin-bottom: 3.5px;
            }
            & > div {
                width: 40px;
                height: 2px;
                background-color: #fff;
            }
        }
    }
}

.body_content {
    padding: 36px 20px 46px;
    & h1 {
        padding-bottom: 24px;
    }

    & .dy_list {
        display: flex;
        flex-wrap: wrap;
        & .dy_list_items {
            width: 161.5px;
            height: 86px;
            background-color: #fff;
            display: flex;
            align-items: center;
            border-radius: 5px;
            padding-left: 10px;
            box-sizing: border-box;
            & img {
                width: 32px;
                height: 32px;
                margin-right: 12px;
            }
            & div {
                width:95px;
                letter-spacing: 0;
                & p:first-child {
                    font-size: 14px;
                    color: #000000;
                    line-height: 18px;
                    padding-bottom: 4px;
                }
                & p:last-child {
                    font-size: 12px;
                    color: #666666;
                    line-height: 16px;
                }
            }
        }
        & .dy_list_items:nth-child(1),
        & .dy_list_items:nth-child(2),
        & .dy_list_items:nth-child(3),
        & .dy_list_items:nth-child(4) {
            margin-bottom: 11.5px;
        }
        & .dy_list_items:nth-child(1),
        & .dy_list_items:nth-child(3),
        & .dy_list_items:nth-child(5) {
            margin-right: 12px;
        }
    }

    & .hj_img {
        width: 100%;
        display: block;
    }

    & .job_content_section,
    & .job_content_cell {
        height: 44px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #cccccc;
        & span {
            width: 33.3%;
            font-size: 12px;
            color: #000000;
            letter-spacing: 0;
            text-align: center;
        }
        & span > a {
            margin: 0 auto;
        }
    }

    & .job_content_cell_selected {
        background: #e5e5e5;
    }

    & .job_content_detail {
        padding: 0 10px;
        padding-bottom: 46px;
        border-bottom: 1px solid #ccc;
        & > div {
            padding: 24px 0;
            & p {
                font-size: 12px;
                color: #ff9200;
                letter-spacing: 0;
            }
            & pre {
                font-size: 12px;
                color: #666666;
                letter-spacing: 0;
                line-height: 20px;
                white-space: pre-wrap;
                white-space: -moz-pre-wrap;
                white-space: -pre-wrap;
                white-space: -o-pre-wrap;
                word-wrap: break-word;
            }
        }
        & > div:nth-child(1) {
            border-bottom: 1px solid #ccc;
        }
    }

    a {
        display: block;
        width: 60px;
        height: 25px;
        text-align: center;
        line-height: 25px;
        font-size: 12px;
        letter-spacing: 0;
        color: #fff;
        background: #ff9200;
        border-radius: 2.5px;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
}
</style>